/** The blue-to-teal brand signature as a thin decorative line. One per region of the screen (DESIGN_SYSTEM.md). */
export const BrandLine = ({ height = 3 }: { height?: number }) => (
  <div aria-hidden="true" style={{ height, background: "var(--cy-brand-gradient)", borderRadius: 999 }} />
);
